import { getAuth } from 'firebase/auth';

import firebase from '../firebase';

const GENERATE_EXPORT_URL =
  'https://us-central1-cheereval.cloudfunctions.net/generateTryoutExport';

export interface GenerateTryoutExportResponse {
  exportId: string;
  downloadUrl: string;
}

export class TryoutExportError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TryoutExportError';
  }
}

export async function generateTryoutExport(
  tryoutId: string,
): Promise<GenerateTryoutExportResponse> {
  const user = getAuth(firebase).currentUser;
  if (!user) {
    throw new TryoutExportError('You must be signed in to export a tryout.');
  }
  const idToken = await user.getIdToken();

  let response: globalThis.Response;
  try {
    response = await fetch(GENERATE_EXPORT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ tryoutId }),
    });
  } catch (err) {
    console.error('[generateTryoutExport] fetch failed:', err);
    throw new TryoutExportError(
      'Could not reach the server. Please check your connection and try again.',
    );
  }

  if (!response.ok) {
    let message = 'Export failed. Please try again.';
    try {
      const body = (await response.json()) as { error?: string };
      if (typeof body.error === 'string' && body.error.length > 0) {
        message = body.error;
      }
    } catch {
      console.error('[generateTryoutExport] server returned HTTP', response.status);
    }
    throw new TryoutExportError(message);
  }

  const data = (await response.json()) as GenerateTryoutExportResponse;
  return data;
}
